import {
	epgu_1,
	epgu_2,
	epgu_3,
	epgu_4,
} from '../assets/images/epgu/images.js';

const options_epgu = [
	{
		title: 'Обработка запроса с ЕПГУ с типом заявления «Уточнение сведений»',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Запросы с ЕПГУ» в левом боковом меню.',
					'3. Выберите запрос с типом заявления «Уточнение сведений» и статусом «Ожидает обработки».',
					'4. Проверьте данные.',
				],
				image: epgu_1.epgu_1_1,
			},
			{
				title: 'В случае положительного результата проверки данных',
				text: [
					'5. Создайте карточку ЛПХ с уточненными данными.',
					'6. Выберите «Положительный ответ» и при необходимости оставьте комментарий.',
					'7. Нажмите на кнопку «Направить ответ» в правом верхнем углу.',
				],
				image: epgu_1.epgu_1_2,
			},
			{
				title: 'В случае отрицательного результата проверки данных',
				text: [
					'8. Выберите «Отказ» и при необходимости оставьте комментарий.',
					'9. Нажмите на кнопку «Отказать» в правом верхнем углу.',
				],
				image: epgu_1.epgu_1_3,
			},
		],
	},
	{
		title:
			'Обработка запроса с ЕПГУ с типом заявления «Выписка в произвольной форме»',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Запросы с ЕПГУ» в левом боковом меню.',
					'3. Выберите запрос с типом заявления «Выписка в произвольной форме» и статусом «Ожидает обработки»',
					'4. Проверьте данные.',
				],
				image: epgu_2.epgu_2_1,
			},
			{
				title: 'В случае положительного результата проверки данных',
				text: [
					'5. Сформируйте выписку в произвольной форме согласно атрибутам, указанным в запросе (см. Раздел «Похозяйственные книги», пункты «Как сформировать выписку в произвольной форме»).',
					'6. Выберите «Положительный ответ» и при необходимости оставьте комментарий.',
					'7. Нажмите на кнопку «Добавить выписку».',
					'8. Выберите сформированную выписку из списка и нажмите на кнопку «Сохранить».',
					'9. Нажмите на кнопку «Направить ответ» в правом верхнем углу.',
				],
				image: epgu_2.epgu_2_2,
			},
			{
				title: 'В случае отрицательного результата проверки данных',
				text: [
					'8. Выберите «Отказ» и при необходимости оставьте комментарий.',
					'9. Нажмите на кнопку «Отказать» в правом верхнем углу.',
				],
				image: epgu_2.epgu_2_3,
			},
			{
				text: ['10. Запрос успешно обработан.'],
			},
		],
	},
	{
		title:
			'Обработка запроса с ЕПГУ с типом заявления «Выписка по форме книги»',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Запросы с ЕПГУ» в левом боковом меню.',
					'3. Выберите запрос с типом заявления «Выписка по форме книги» и статусом «Ожидает обработки».',
					'4. Проверьте данные.',
				],
				image: epgu_3.epgu_3_1,
			},
			{
				title: 'В случае положительного результата проверки данных',
				text: [
					'5. Сформируйте выписку по форме книги согласно атрибутам, указанным в запросе (см. Раздел «Похозяйственные книги», пункты «Как сформировать выписку по форме книги»).',
					'6. Выберите «Положительный ответ» и при необходимости оставьте комментарий.',
					'7. Нажмите на кнопку «Добавить выписку».',
					'8. Выберите сформированную выписку из списка и нажмите на кнопку «Сохранить».',
					'9. Нажмите на кнопку «Направить ответ» в правом верхнем углу.',
				],
				image: epgu_3.epgu_3_2,
			},
			{
				title: 'В случае отрицательного результата проверки данных',
				text: [
					'8. Выберите «Отказ» и при необходимости оставьте комментарий.',
					'6. Нажмите на кнопку «Отказать» в правом верхнем углу.',
				],
				image: epgu_3.epgu_3_3,
			},
			{
				text: ['10. Запрос успешно обработан.'],
			},
		],
	},
	{
		title:
			'Обработка запроса с ЕПГУ с типом заявления «Выписка НПЗУ» (Выписка о наличии у гражданина права на земельный участок)',
		instructions: [
			{
				text: [
					'1. Зайдите на главную страницу сервиса (для этого нажмите на логотип сервиса в левом верхнем углу).',
					'2. Перейдите в раздел «Запросы с ЕПГУ» в левом боковом меню.',
					'3. Выберите запрос с типом заявления «Выписка НПЗУ» и статусом «Ожидает обработки».',
					'4. Проверьте данные.',
				],
				image: epgu_4.epgu_4_1,
			},
			{
				title: 'В случае положительного результата проверки данных',
				text: [
					'5. Сформируйте выписку НПЗУ (Выписка о наличии у гражданина права на земельный участок) согласно атрибутам, указанным в запросе (см. Раздел «Похозяйственные книги», пункты «Как сформировать выписку о наличии у гражданина прав на земельный участок (Выписка НПЗУ)»).',
					'6. Выберите «Положительный ответ» и при необходимости оставьте комментарий.',
					'7. Нажмите на кнопку «Добавить выписку».',
					'8. Выберите сформированную выписку из списка и нажмите на кнопку «Сохранить».',
					'9. Нажмите на кнопку «Направить ответ» в правом верхнем углу.',
				],
				image: epgu_4.epgu_4_2,
			},
			{
				title: 'В случае отрицательного результата проверки данных',
				text: [
					'8. Выберите «Отказ» и при необходимости оставьте комментарий.',
					'9. Нажмите на кнопку «Отказать» в правом верхнем углу.',
				],
				image: epgu_4.epgu_4_3,
			},
			{
				text: ['10. Запрос успешно обработан.'],
			},
		],
	},
];

export default options_epgu;
